if ( typeof CartForm !== 'function' ) {
	class CartForm extends HTMLElement {

		constructor(){
			super();
			this.ajaxifyCartItems();
		}

		ajaxifyCartItems(){

			this.form = this.querySelector('form');

			this.querySelectorAll('[data-js-cart-item]').forEach(item=>{

				const remove = item.querySelector('.remove');
				if ( remove ) {
					remove.dataset.href = remove.getAttribute('href');
					remove.setAttribute('href', '');
					remove.addEventListener('click', (e)=>{
						e.preventDefault();
						this.updateCartQty(item, 0);
					})
				}

				const qty = item.querySelector('.qty');
				if ( qty ) {
					qty.addEventListener('input', debounce(e=>{
						e.preventDefault();
						e.target.blur();
						this.updateCartQty(item, parseInt(qty.value));
					}, 300));
					qty.addEventListener('click', (e)=>{
						e.target.select();
					})
				}

			})

		}

		updateCartQty(item, newQty){

			this.form.classList.add('processing');
			if ( this.querySelector('.alert') ) {
				this.querySelector('.alert').remove();
			}

			const body = JSON.stringify({
				id: item.dataset.id,
				quantity: newQty
			});

			fetch(KROWN.settings.routes.cart_change_url, {
					method: 'POST',
					headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
					body
				})
				.then(response => {
					if ( response.ok ) {
						return fetch('?section_id=helper-cart')
					} else {
						throw new Error('Something went wrong');
					}
				})
				.then(response => response.text())
				.then(text => {

					const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
					const cartFormInnerHTML = sectionInnerHTML.getElementById('AjaxCartForm').innerHTML;
					const cartSubtotalInnerHTML = sectionInnerHTML.getElementById('AjaxCartSubtotal').innerHTML;

					const cartItems = document.getElementById('AjaxCartForm');
					cartItems.innerHTML = cartFormInnerHTML;
					cartItems.ajaxifyCartItems();

					document.querySelectorAll('[data-header-cart-count]').forEach(elm=>{
						elm.textContent = cartItems.querySelector('[data-cart-count]').textContent;
					});
					document.querySelectorAll('[data-header-cart-total').forEach(elm=>{
						elm.textContent = cartItems.querySelector('[data-cart-total]').textContent;
					});

					if ( newQty != 0 && cartItems.querySelector(`[data-js-cart-item][data-id="${item.dataset.id}"]`) && newQty > parseInt(cartItems.querySelector(`[data-js-cart-item][data-id="${item.dataset.id}"]`).dataset.qty) ) {
						let alert = document.createElement('span');
						alert.classList.add('alert', 'alert--error');
						alert.innerHTML = KROWN.settings.locales.cart_add_error.replace('{{ title }}', item.dataset.title);
						this.form.prepend(alert);
					} 

					document.getElementById('AjaxCartSubtotal').innerHTML = cartSubtotalInnerHTML;
							
					const event = new Event('cart-updated');
					this.dispatchEvent(event);

				})
				.catch(e => {
					console.log(e);
					let alert = document.createElement('span');
					alert.classList.add('alert', 'alert--error');
					alert.textContent = KROWN.settings.locales.cart_general_error;
					this.form.prepend(alert);
				})
				.finally(() => {
					this.form.classList.remove('processing');
				});
		}

	} 


  if ( typeof customElements.get('cart-form') == 'undefined' ) {
		customElements.define('cart-form', CartForm);
	}

}

if ( typeof CartProductQuantity !== 'function' ) {

	class CartProductQuantity extends HTMLElement {
		constructor(){
			super();
			this.querySelector('.qty-minus').addEventListener('click', this.changeCartInput.bind(this));
			this.querySelector('.qty-plus').addEventListener('click', this.changeCartInput.bind(this));
		}
		changeCartInput(){
			setTimeout(()=>{
				document.getElementById('AjaxCartForm').updateCartQty(this.closest('[data-js-cart-item]'), parseInt(this.querySelector('.qty').value));
			}, 50);
		}
	}

  if ( typeof customElements.get('cart-product-quantity') == 'undefined' ) {
		customElements.define('cart-product-quantity', CartProductQuantity);
	}

}

// method for apps to tap into and refresh the cart

if ( ! window.refreshCart ) {

	window.refreshCart = () => {
		
		fetch('?section_id=helper-cart')
			.then(response => response.text())
			.then(text => {

			const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
			const cartFormInnerHTML = sectionInnerHTML.getElementById('AjaxCartForm').innerHTML;
			const cartSubtotalInnerHTML = sectionInnerHTML.getElementById('AjaxCartSubtotal').innerHTML;

			const cartItems = document.getElementById('AjaxCartForm');
			cartItems.innerHTML = cartFormInnerHTML;
			cartItems.ajaxifyCartItems();

			document.querySelectorAll('[data-header-cart-count]').forEach(elm=>{
				elm.textContent = cartItems.querySelector('[data-cart-count]').textContent;
			});
			document.querySelectorAll('[data-header-cart-total').forEach(elm=>{
				elm.textContent = cartItems.querySelector('[data-cart-total]').textContent;
			})
			
			document.getElementById('AjaxCartSubtotal').innerHTML = cartSubtotalInnerHTML;
			if ( document.querySelector('[data-js-site-cart-sidebar]') ) {
				document.querySelector('[data-js-site-cart-sidebar]').show();
			}

			if ( document.querySelector('cart-recommendations') ) {
				document.querySelector('cart-recommendations').innerHTML = '';
				document.querySelector('cart-recommendations').generateRecommendations();
			}

		})

	}

}

// discount code field (snippets/cart-discount.liquid), shown in the cart page summary and the cart drawer footer

if ( typeof CartDiscount !== 'function' ) {

	let cartDiscountBusy = false;

	class CartDiscount extends HTMLElement {

		constructor(){
			super();

			this.form = this.querySelector('form');
			this.input = this.querySelector('input[name="discount"]');
			this.updateUrl = `${this.form.getAttribute('action')}.js`;

			this.form.addEventListener('submit', e=>{
				e.preventDefault();
				const code = this.input.value.trim();
				if ( code ) {
					this.applyCode(code);
				} else {
					this.input.focus();
				}
			});

			this.input.addEventListener('input', ()=>{
				this.showMessage('');
			});

			this.querySelectorAll('[data-js-discount-remove]').forEach(button=>{
				button.addEventListener('click', e=>{
					e.preventDefault();
					this.removeCode(button.closest('[data-discount-code]').dataset.discountCode);
				});
			});
		}

		async applyCode(code){

			if ( cartDiscountBusy ) return;
			this.setBusy(true);

			try {

				// keep codes already on the cart (affiliate links, loyalty rewards), the update replaces the whole list
				const otherCodes = (await this.getCartCodes()).filter(existing => !this.isSameCode(existing, code));
				const cart = await this.setCartCodes([...otherCodes, code]);
				const result = (cart.discount_codes || []).find(discount => this.isSameCode(discount.code, code));

				if ( ! result || ! result.applicable ) {
					// Shopify keeps unusable codes on the cart, so take it back off to match the message
					await this.setCartCodes(otherCodes);
					this.showMessage(this.dataset.errorText, 'error');
					return;
				}

				await this.refreshCart();

				// valid codes that don't show up in the cart yet (e.g. free shipping) are applied at checkout
				const listed = [...document.querySelectorAll('cart-discount [data-discount-code]')].some(item => this.isSameCode(item.dataset.discountCode, code));
				if ( ! listed ) {
					this.showMessage(this.dataset.checkoutText, 'success');
				}

			} catch(e) {
				console.log(e);
				this.showMessage(KROWN.settings.locales.cart_general_error, 'error');
			} finally {
				this.setBusy(false);
			}

		}

		async removeCode(code){

			if ( cartDiscountBusy ) return;
			this.setBusy(true);

			try {
				const codes = await this.getCartCodes();
				await this.setCartCodes(codes.filter(existing => !this.isSameCode(existing, code)));
				await this.refreshCart();
			} catch(e) {
				console.log(e);
				this.showMessage(KROWN.settings.locales.cart_general_error, 'error');
			} finally {
				this.setBusy(false);
			}

		}

		async getCartCodes(){
			const response = await fetch(`${KROWN.settings.routes.cart_url}.js`, { headers: { 'Accept': 'application/json' } });
			if ( ! response.ok ) throw new Error('Something went wrong');
			const cart = await response.json();
			if ( Array.isArray(cart.discount_codes) ) {
				return cart.discount_codes.map(discount => discount.code);
			}
			return [...this.querySelectorAll('[data-discount-code]')].map(item => item.dataset.discountCode);
		}

		async setCartCodes(codes){
			const response = await fetch(this.updateUrl, {
				method: 'POST',
				headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
				body: JSON.stringify({ discount: codes.join(',') })
			});
			if ( ! response.ok ) throw new Error('Something went wrong');
			return response.json();
		}

		// same refresh as quantity changes, so line prices, discounts, totals and the free shipping bar all update
		refreshCart(){
			return fetch('?section_id=helper-cart')
				.then(response => response.text())
				.then(text => {

					const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
					const cartFormInnerHTML = sectionInnerHTML.getElementById('AjaxCartForm').innerHTML;
					const cartSubtotalInnerHTML = sectionInnerHTML.getElementById('AjaxCartSubtotal').innerHTML;

					const cartItems = document.getElementById('AjaxCartForm');
					cartItems.innerHTML = cartFormInnerHTML;
					cartItems.ajaxifyCartItems();

					document.getElementById('AjaxCartSubtotal').innerHTML = cartSubtotalInnerHTML;

					cartItems.dispatchEvent(new Event('cart-updated'));

				});
		}

		isSameCode(a, b){
			return a.trim().toLowerCase() == b.trim().toLowerCase();
		}

		setBusy(busy){
			cartDiscountBusy = busy;
			this.classList.toggle('processing', busy);
			this.setAttribute('aria-busy', busy);
		}

		// after a refresh this element is replaced, so always write into the one on the page
		showMessage(text, type){
			const holder = document.querySelector('cart-discount [data-js-discount-message]');
			if ( ! holder ) return;
			holder.innerHTML = '';
			if ( text ) {
				const message = document.createElement('span');
				message.classList.add('alert', 'alert--unstyled', 'alert--circle', `alert--${type}`);
				message.textContent = text;
				holder.append(message);
			}
		}

	}

	if ( typeof customElements.get('cart-discount') == 'undefined' ) {
		customElements.define('cart-discount', CartDiscount);
	}

}